/* eslint-disable */
import useAuth from "../../../../../hooks/useAuth";
import {useTheme} from "@material-ui/core/styles";
import {useStyles} from "../../style";
import {Box, Grid, Typography} from "@material-ui/core";
import {Card} from '@material-ui/core';
import Chart from "react-apexcharts";
import iconoVentas from "../../../../../assets/icons/indicadores.svg";
import React, { useMemo, useState } from "react";
import es from "../../../../../assets/languagePackages/es.json";

const ChartLineZoom = ({ data, props }) => {
    console.log("propsIFLineChart", props)
    console.log("data", data)
    const { user } = useAuth();
    const theme = useTheme();
    const classes = useStyles([]);

    
    
    const [zoomChart, setZoomChart] = useState({
        options: {
            chart: {
                locales: [es],
                defaultLocale: 'es',
                fontFamily: 'Roboto, sans-serif',
                height: '100%',
                width: '100%'
            },
            colors: ['#034886','#034886'],
            dataLabels: {
                enabled: false,
            },
            tooltip : {
                enabled: true,
                custom: function({series, seriesIndex, dataPointIndex, w}) {
                        const nameIngreso = w.config.series[0].name;
                        const ingresoValue = w.config.series[seriesIndex].data[dataPointIndex] !== undefined ? w.config.series[seriesIndex].data[dataPointIndex] : [null,0];
                        const date = new Date(ingresoValue[0]);
                        const day = String(date.getUTCDate()).padStart(2, '0');
                        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                        const year = String(date.getUTCFullYear()).slice(-2);
                        const formattedIngresoValue = props.valType === "money" ? series[seriesIndex][dataPointIndex].toLocaleString(undefined, {
                                style: 'currency',
                                currency: 'USD',
                        }) : props.valType === "percentage" ? `${(series[seriesIndex][dataPointIndex] * 100).toFixed(2)}%` : `${series[seriesIndex][dataPointIndex]}`
                        const formattedDate = `${day}/${month}/${year}`;
                        let backgroundColor = w.config.colors[0];
                        return `
                        <div style="border-radius:5px;font-family:'Roboto',serif;">
                            <div style="display:flex;background:#ECEFF1;border-bottom:thin solid #ddd;padding-top:10px;padding-left:10px;padding-right:10px;padding-bottom:5px">
                                <p style=margin-left:5px>Fecha: <span style=font-weight:bold>${formattedDate}</span></p>
                            </div>
                            <div style="padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:5px">
                                <div style="display:flex;align-items:center">
                                    <span style="background-color:${backgroundColor};width:12px;height:12px;border-radius:50%;margin-right:5px"></span>
                                    <p>${nameIngreso}: <span style="font-weight:bold">${formattedIngresoValue}</span></p>
                                </div>
                            </div>
                        </div>`
                }
            },
            xaxis: {
                type: 'datetime',
            },
            yaxis: {
                x: props.valType,
                labels: {
                    formatter: function (y) {

                        return `${props.valType}`
                    }

                }
            },
            stroke: {
                width: 1,
                curve: 'straight',
            }
        },
        series : [{
            name: props.name,
            data: props.series
        }]
    })


    const chartConfig = useMemo(() => {
  const valType = props.valType ?? '';
  console.log("chartConfig valType:", valType);
  return {
    options: {
      chart: {
        locales: [es],
        defaultLocale: 'es',
        fontFamily: 'Roboto, sans-serif',
        height: '100%',
        width: '100%'
      },
      colors: ['#034886', '#034886'],
      dataLabels: { enabled: false },
      tooltip: {
        enabled: true,
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          const nameIngreso = w.config.series[0].name;
          const ingresoValue = w.config.series[seriesIndex].data[dataPointIndex] ?? [null, 0];
          const date = new Date(ingresoValue[0]);
          const formattedDate = date.toLocaleDateString('es-ES');
          const formattedIngresoValue = props.valType === "money" ? series[seriesIndex][dataPointIndex].toLocaleString(undefined, {
                                style: 'currency',
                                currency: 'USD',
                        }) : props.valType === "percentage" ? `${(series[seriesIndex][dataPointIndex]*100).toFixed(2)}%` : `${series[seriesIndex][dataPointIndex].toFixed(2)}`
          return `
            <div style="border-radius:5px;font-family:'Roboto',serif;">
              <div style="display:flex;background:#ECEFF1;border-bottom:thin solid #ddd;padding:10px">
                <p>Fecha: <span style="font-weight:bold">${formattedDate}</span></p>
              </div>
              <div style="padding:10px">
                <div style="display:flex;align-items:center">
                  <span style="background-color:#034886;width:12px;height:12px;border-radius:50%;margin-right:5px"></span>
                  <p>${nameIngreso}: <span style="font-weight:bold">${formattedIngresoValue}</span></p>
                </div>
              </div>
            </div>`;
        }
      },
      xaxis: { type: 'datetime' },
      yaxis: {
        tickAmount: 5,
        labels: {
          formatter: function(y){
                                    if (props.valType === "percentage"){
                                        return `${(y*100).toFixed(2)}%`
                                    }else if (props.valType === "number"){
                                        return `${new Intl.NumberFormat('en-US', {
                                            style: "decimal",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).format(y)}`
                                    }else if(props.valType === "money"){
                                        return `$${formatCurrencyNumber(y)}`
                                    }
                                }
        }
      },
      stroke: {
        width: 1,
        curve: 'straight',
      }
    },
    series: [{
      name: props.name,
      data: props.series
    }]
  };
}, [props.valType, props.name, props.series]);


    console.log("chartConfig", chartConfig)

    
    function formatCurrencyNumber(number) {
        if (number === null || number === undefined) return '0';

        const suffixes = ['', 'K', 'M', 'B', 'T'];
        let i = 0;
        let absNumber = Math.abs(number);

        while (absNumber >= 1000 && i < suffixes.length - 1) {
            absNumber /= 1000;
            i++;
        }

        const formatted = absNumber % 1 === 0 ? absNumber.toFixed(0) : absNumber.toFixed(1);
        const sign = number < 0 ? '-' : '';

        return `${sign}${formatted}${suffixes[i]}`;
        }


    return (

        <Grid component={Card} padding={3} height='100%'>
            <Grid className={classes.chartLineBarsBox} item xs={12} md={12}>
                <div>
                    <img src={iconoVentas} alt="foto" width="30px" height="30px"/>
                </div>
                <Typography className={classes.chartBarDonutTitle} paddingLeft={2}>
                    {props.name}
                </Typography>
            </Grid>
            <Grid item xs={12} md={12} height='88%'>
                <Chart
                key = {props.id}
                    type='area'
                    width="100%"
                    height="100%"
                    {...chartConfig}
                
                />
            </Grid>
        </Grid>
    );
};

export default ChartLineZoom;